/** Incremented keys replay a finite status wash even when the copy is unchanged. */

import { useCallback, useState } from "react";
import { haptics } from "@/lib/haptics";
export function useSuccessFeedback(): { success: () => void; version: number; clear: () => void } {
  const [version, setVersion] = useState(0);
  const success = useCallback(() => { haptics("success"); setVersion(value => value + 1); }, []);
  const clear = useCallback(() => setVersion(0), []);
  return { success, version, clear };
}
